import React from 'react';
import { TabsProps } from 'antd';

import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { createMenuLabel } from '@totem/components/ui_components/menus/utilities';

type Props = {
  defaultItem?: string;
  items: IBMenuItem[];
};

const TabContentMenu = ({ items, defaultItem }: Props) => {
  const mapMenuItems = (): TabsProps['items'] => {
    return items.map((item: IBMenuItem) => {
      return {
        key: item.key,
        title: item.title,
        label: item.label,
        icon: item.icon,
        children: item.content,
      };
    });
  };

  return <IBTabs defaultActiveKey={defaultItem} items={mapMenuItems()} />;
};

export default TabContentMenu;
